import { Epic, ofType } from "redux-observable";
import { RootState } from "../../store";
import * as authSelectors from "../auth/authSelectors";
import * as subscriptionActions from "./subscriptionActions";
import { ServiceContainer } from "../../serviceContainer";
import { catchError, exhaustMap, map, mergeMap, tap } from "rxjs/operators";
import { of } from "rxjs";

export const subscriptionListForUser: Epic<
  any,
  any,
  RootState,
  ServiceContainer
> = (action$, state$, services) =>
  action$.pipe(
    ofType(subscriptionActions.GET_SUBSCRIPTION_LIST_FOR_USER),
    exhaustMap((action: subscriptionActions.GetSubscriptionListForUser) => {
      const state = state$.value;

      return services.apiSubscription
        .listByUserAndOrganization(
          authSelectors.accessToken(state),
          action.organizationKeyName,
          action.userId
        )
        .pipe(
          map((x) =>
            subscriptionActions.getSubscriptionListForUserSuccess(
              action.organizationKeyName,
              action.userId,
              x.subscriptions.items
            )
          ),
          catchError(() => {
            services.toastr.error(
              "Error",
              "There was error while fetching user subscriptions"
            );
            return of(
              subscriptionActions.getSubscriptionListForUserFail(
                action.organizationKeyName,
                action.userId
              )
            );
          })
        );
    })
  );

export const planListForOrganization: Epic<
  any,
  any,
  RootState,
  ServiceContainer
> = (action$, state$, services) =>
  action$.pipe(
    ofType(subscriptionActions.GET_PLAN_LIST_FOR_ORGANIZATION),
    exhaustMap(
      (action: subscriptionActions.GetPlanListForOrganizationAction) => {
        const state = state$.value;

        return services.apiPlan
          .listByOrganization(
            authSelectors.accessToken(state),
            action.organizationKeyName
          )
          .pipe(
            map((x) =>
              subscriptionActions.getPlanListForOrganizationSuccessAction(
                action.organizationKeyName,
                x.plans
              )
            ),
            catchError(() => {
              services.toastr.error(
                "Error",
                "There was error while fetching subscription plans"
              );
              return of(
                subscriptionActions.getPlanListForOrganizationFailAction(
                  action.organizationKeyName
                )
              );
            })
          );
      }
    )
  );

export const cancelSubscription: Epic<any, any, RootState, ServiceContainer> = (
  action$,
  state$,
  services
) =>
  action$.pipe(
    ofType(subscriptionActions.CANCEL_SUBSCRIPTION_FOR_USER),
    mergeMap((action: subscriptionActions.CancelSubscriptionForUser) => {
      const state = state$.value;

      return services.apiSubscription
        .cancelByIdAndOrganization(
          authSelectors.accessToken(state),
          action.organization,
          action.subscriptionId,
          action.cancelImmediately
        )
        .pipe(
          map(() =>
            subscriptionActions.cancelSubscriptionForUserSuccess(
              action.organization,
              action.userId,
              action.subscriptionId
            )
          ),
          tap(() =>
            services.toastr.success("Success", "Subscription has been canceled")
          ),
          catchError(() => {
            services.toastr.error(
              "Fail",
              "There was error while canceling subscription"
            );
            return of(
              subscriptionActions.cancelSubscriptionForUserFail(
                action.organization,
                action.userId,
                action.subscriptionId
              )
            );
          })
        );
      /* .concat(
          of(
            subscriptionActions.getSubscriptionListForUser(
              action.organization,
              action.userId
            )
          )
        ); */
    })
  );
